import React from "react"
import { Grid, FormControl, Select, MenuItem } from "@material-ui/core"
import { ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"
import { WABAChannelChatFreeEntryPointWindowStatusOnFilter } from "@/@integrations/WABA/protocols/wabaChannelChatFreeEntryPointWindow"

type MetaFreeEntryPointWindowFilterConditionProps = {
	condition: ContactsFiltersConditions<"contact_meta_free_entry_point_window">
	onChange: (condition: ContactsFiltersConditions<"contact_meta_free_entry_point_window">) => void
}

const ACCEPTED_META_FREE_ENTRY_POINT_WINDOW_STATUSES: WABAChannelChatFreeEntryPointWindowStatusOnFilter[] = [
	"active",
	"paused",
	"expiring"
]

const statusLabels: Record<WABAChannelChatFreeEntryPointWindowStatusOnFilter, string> = {
	active: "Ativa",
	paused: "Inativa",
	expiring: "Prestes a encerrar"
}

const MetaFreeEntryPointWindowFilterCondition: React.FC<MetaFreeEntryPointWindowFilterConditionProps> = (props) => {
	const { condition, onChange } = props

	const handleStatusChange = (status: WABAChannelChatFreeEntryPointWindowStatusOnFilter) => {
		onChange({
			type: "contact_meta_free_entry_point_window",
			operator: "equal",
			filterData: { status }
		})
	}

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						value={condition.filterData.status}
						onChange={({ target }) =>
							handleStatusChange(target.value as WABAChannelChatFreeEntryPointWindowStatusOnFilter)
						}
					>
						{ACCEPTED_META_FREE_ENTRY_POINT_WINDOW_STATUSES.map(status => (
							<MenuItem key={status} value={status}>
								{statusLabels[status]}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}

export default MetaFreeEntryPointWindowFilterCondition
